__turbopack_context__.v({
  "accordionSlideOverwrite": "eventPopup-module-scss-module__wttW5G__accordionSlideOverwrite",
  "fadeIn": "eventPopup-module-scss-module__wttW5G__fadeIn",
  "fadeOut": "eventPopup-module-scss-module__wttW5G__fadeOut",
  "popup": "eventPopup-module-scss-module__wttW5G__popup",
  "scaleIn": "eventPopup-module-scss-module__wttW5G__scaleIn",
  "scaleOut": "eventPopup-module-scss-module__wttW5G__scaleOut",
  "zoomIn": "eventPopup-module-scss-module__wttW5G__zoomIn",
  "zoomOut": "eventPopup-module-scss-module__wttW5G__zoomOut",
});
